import assign from 'lodash/assign';

import MultiAnalyticsModule from 'app/shared/utils/analytics';
import { setComscore } from 'app/shared/flux/actions/AnalyticsActions';

function setupRouting(dispatch) {
    const ma = MultiAnalyticsModule.getInstance().getMa();
    window.browserHistory.listen((location) => {
        if (location.action === 'POP') {
            return;
        }
        const prevLocation =
            window.store.getState() && window.store.getState().router && window.store.getState().router.location;
        if (prevLocation && prevLocation.pathname === location.pathname) {
            // do not scroll to top if only the query changed
            return;
        }

        window.scrollTo(0, 0);
    });

    window.router = {
        redirectTo(t) {
            return window.browserHistory.replace(t);
        },
        transitionTo(t) {
            const currentState = assign({}, window.history.state, {
                scrollTop: document.body.scrollTop
            });

            window.history.replaceState(currentState, document.title, window.location.href);

            ma.trackPageView(
                {
                    path: t
                },
                null,
                () => dispatch(setComscore())
            );

            return window.browserHistory.push(t);
        }
    };
}

export default setupRouting;
